import React from "react";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { LABELS } from "../../../../constants/labels/help.labels";

const Pump: React.FC = () => {
  const { pumpCollapse } = useAppSelector((state) => state?.collapse);

  const { updatePumpCollapse } =
    useCollapseFacade();

  const handleCollapseChange = (key: boolean, name: string) => {
    if (name === "PC") updatePumpCollapse(key);
  };

  return (
    <>
      <div className='flex flex-col justify-center item-center w-full h-full gap-[16px] text-white'>
        <Accordion
          title={LABELS?.pumpFormulas}
          id={'PC'}
          isOpen={!pumpCollapse}
          onToggle={() => handleCollapseChange(!pumpCollapse, "PC")}
          content={
            <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
              <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                <table className='table-auto w-full border-collapse'>
                  <colgroup>
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "40%" }} />
                  </colgroup>
                  <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                    <th className='align-center px-[24px] py-[16px] font-normal'>Motor full load speed @ 60 Hz</th>
                    <td className="px-[24px] py-[16px]">
                      <p className='secondary'>
                        Max speed of motor, if specified on motor or else 3500
                      </p>
                    </td>
                    <th className='align-center px-[24px] py-[16px] font-normal'>Lift/Stage</th>
                    <td colSpan={3} className='col-5 px-[24px] py-[16px]'>
                      <div className='pb-4 secondary'>
                        H0 + H1 + ProductionCapacity + H2 * ProductionCapacity ^ 2
                        + H3 * ProductionCapacity ^ 3 + H4 * ProductionCapacity ^
                        2 + H5 * ProductionCapacity ^ 2 *
                        Pump_Head_Correction_Factor * 3500 / Speed_At_OperFreq
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>Speed_At_OperFreq :</p>
                        <p className='secondary-text'>
                          Operating_Frequency * Speed_Of_Motor / 60
                        </p>
                      </div>
                      <div className=''>
                        <p className='secondary'>Production capacity :</p>
                        <p className='secondary-text'>
                          ProductionRate / Pump_Capacity_Correction_Factor * 3500
                          / Speed_At_OperFreq
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                    <th className='align-center px-[24px] py-[16px] font-normal'>Power @ Operating_Frequency</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='pb-4 secondary'>
                        Desired_No._Of_Stages * Final_Target_BHP
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>Speed_At_OperFreq :</p>
                        <p className='secondary-text'>
                          Operating_Frequency * Speed_Of_Motor / 60
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>Target_BHP :</p>
                        <p className='secondary-text'>
                          B0 + B1 * ProductionCapacity + B2 * ProductionCapacity ^
                          2 + B3 * ProductionCapacity ^ 3 + B4 *
                          ProductionCapacity ^ 4 + B5 * ProductionCapacity ^ 5
                        </p>
                      </div>
                      <div className=''>
                        <p className='secondary'>Final_Target_BHP :</p>
                        <p className='secondary-text'>
                          Target_BHP * PowerCorrectionFactor * (Speed_At_OperFreq
                          / 3500) ^ 3
                        </p>
                      </div>
                    </td>
                    <th className='align-center px-[24px] py-[16px] font-normal'>Total dynamic head over override</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>
                        Total dynamic head over override
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                    <th className='align-center px-[24px] py-[16px] font-normal'>Flow correction</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>
                        <p className="pb-4">FlowCorrectionFactor = capacityCalc;</p>
                        <p className=''>
                          <b>if (viscosity is greater than MaxViscosity)</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          capacityCalc =VQ1 + VQ2 * MaxViscosity + VQ3 *
                          (MaxViscosity^2) + VQ4 * (MaxViscosity^3);
                          (MaxViscosity^3);
                        </p>
                        <b> Else</b>
                        <p className='pl-2 pb-4'>
                          capacityCalc = VQ1 + VQ2 * viscosity + VQ3 *
                          (viscosity^2) + VQ4 * (viscosity^3);
                        </p>
                      </div>
                      <div className=''>
                        <p className='secondary'>
                          <b>if (viscosity is Less than MinViscosity)</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          capacityCalc = 1;
                        </p>
                        <p className='secondary'>
                          <b>if (capacityCalc is greater than 1)</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          FlowCorrectionFactor = 1;
                        </p>
                        <p className='secondary'>
                          <b>
                            else if (capacityCalc &lt;= 1 && capacityCalc &gt; 0)
                          </b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          FlowCorrectionFactor = capacityCalc;
                        </p>
                        <p className='secondary'>
                          <b>else</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          FlowCorrectionFactor = 1;
                        </p>
                        <p className='secondary'>
                          VQ1,VQ2,VQ3,VQ4,MinViscosity,MaxViscosity
                        </p>
                        <p className='secondary'>
                          <b>ESPCatalog (DR_Pumps) in database</b>
                        </p>
                      </div>
                    </td>
                    <th className='align-center px-[24px] py-[16px] font-normal'>Power @ 60 Hz</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='pb-3 secondary'>
                        Desired_No._Of_Stages * Final_Target_BHP
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>Speed_At_OperFreq :</p>
                        <p className='secondary-text'>
                          60 * Speed_Of_Motor / 60
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>Target_BHP :</p>
                        <p className='secondary-text'>
                          B0 + B1 * ProductionCapacity + B2 * ProductionCapacity ^
                          2 + B3 * ProductionCapacity ^ 3 + B4 *
                          ProductionCapacity ^ 4 + B5 * ProductionCapacity ^ 5
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>Final_Target_BHP :</p>
                        <p className='secondary-text'>
                          Target_BHP * PowerCorrectionFactor * (Speed_At_OperFreq
                          / 3500) ^ 3
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                    <th className='align-center px-[24px] py-[16px] font-normal'>Desired no. of stages</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>
                        If (Desired no. of stages entered) then same as "Desired
                        no. of stages" entered else "Min no. of stages"
                      </div>
                    </td>
                    <th className="align-center px-[24px] py-[16px] font-normal">Head correction</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>
                        <p className="pb-4">HeadCorrectionFactor = headCalc;</p>
                        <p className=''>
                          <b>if (viscosity is greater than MaxViscosity)</b>
                        </p>
                        <p className='pl-2 pb-4'>
                          headCalc = VH1 +VH2 * MaxViscosity + VH3 *
                          (MaxViscosity^2) + VH4 * (MaxViscosity^3);
                        </p>
                        <b> Else</b>
                        <p className='pl-2 pb-4'>
                          headCalc = VH1 + VH2 * viscosity + VH3 * (viscosity^2) +
                          VH4 * (viscosity^3);
                        </p>
                      </div>
                      <div className=''>
                        <p className='secondary'>
                          <b>if (viscosity is less than MinViscosity)</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>headCalc = 1</p>
                        <p className='secondary'>
                          <b>if (headCalc is greater than 1)</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          HeadCorrectionFactor = 1;
                        </p>
                        <p className='secondary'>
                          <b>
                            else if (headCalc greater than 0 & headCalc Less than
                            or equal to 1)
                          </b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          HeadCorrectionFactor = headCalc;
                        </p>
                        <p className='secondary'>
                          <b>else</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          HeadCorrectionFactor = 1;
                        </p>
                        <p className='secondary'>
                          VH1,VH2,VH3,VH4,MinViscosity,MaxViscosity
                        </p>
                        <p className='secondary'>
                          <b>ESPCatalog (DR_Pumps) in database</b>
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                    <th className='align-center px-[24px] py-[16px] font-normal'>Efficiency</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>
                        ProductionRate * LiftPerStage / Power_At_Oper_Freq /
                        135773 * 100
                      </div>
                    </td>
                    <th className="align-center px-[24px] py-[16px] font-normal">Min no. of stages</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>TDH / LiftPerStage</div>
                    </td>
                  </tr>
                  <tr className="border-b-[1px] border-darkcolor-400 text-[14px] font-normal">
                    <th className='align-center px-[24px] py-[16px] font-normal'>Power correction</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>
                        <p className="pb-4">
                          PowerCorrectionFactor = powercalc * SpecificGravity;
                        </p>
                        <p className=''>
                          <b>if (viscosity is greater than MaxViscosity)</b>
                        </p>
                        <p className='pl-2 pb-4'>
                          powercalc = VP1 +VP2 * MaxViscosity + VP3 *
                          (MaxViscosity^2) + VP4 * (MaxViscosity^3);
                        </p>
                        <b> Else</b>
                        <p className='pl-2 pb-4'>
                          powercalc = VP1 + VP2 * viscosity + VP3 * (viscosity^2)
                          + VP4 * (viscosity^3);
                        </p>
                      </div>
                      <div className=''>
                        <p className='secondary'>
                          <b>if (viscosity is less than MinViscosity)</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>powercalc = 1</p>
                        <p className='secondary'>
                          <b>if (powercalc is greater than 1)</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          PowerCorrectionFactor = SpecificGravity;
                        </p>
                        <p className='secondary'>
                          <b>
                            else if (powercalc greater than or equal 0 & powercalc
                            less than 0)
                          </b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          PowerCorrectionFactor = powercalc * SpecificGravity;
                        </p>
                        <p className='secondary'>
                          <b>else</b>
                        </p>
                        <p className='secondary-text pl-2 pb-4'>
                          PowerCorrectionFactor = 1;
                        </p>
                        <p className='secondary'>
                          VP1,VP2,VP3,VP4,MinViscosity,MaxViscosity
                        </p>
                        <p className='secondary'>
                          <b>ESPCatalog (DR_Pumps) in database</b>
                        </p>
                      </div>
                    </td>
                    <th className='align-center px-[24px] py-[16px] font-normal'>Target flow rate</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>
                        Total fluid volume from gas calculations
                      </div>
                    </td>
                  </tr>
                  <tr className="text-[14px] font-normal">
                    <th className='align-center px-[24px] py-[16px] font-normal'>Final TDH</th>
                    <td className="px-[24px] py-[16px]">
                      <div className='secondary'>
                        Desired no. of stages * LiftPerStage
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          }
        />
      </div>
    </>
  );
};

export default Pump;
